import React from "react";
import { styled, Text, Heading } from "@sourceful/shared-components";
import { SanityLearnMoreModalContentBlock, SanityLearnMoreModal } from "@sourceful/shared-types";
import { BlockContent } from "@lib/sanity-components";
import { getSanityImgUrl } from "@lib/sanity";
import toRem from "../../styles/postprocess/conversion/to-rem";

const Wrapper = styled("div", {
  width: "100%",
  display: "grid",
  gridGap: toRem(20),
  variants: {
    imagePosition: {
      top: {},
      left: {
        gridTemplateColumns: "200px 1fr",
        alignItems: "center",
      },
      right: {
        gridTemplateColumns: "200px 1fr",
        alignItems: "center",
        direction: "rtl",
      },
      noImage: {},
    },
  },
});

const Image = styled("img", {
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
});

const TextWrapper = styled("div", {
  minWidth: 0,
  maxWidth: "100%",
});

interface LearnMoreModalContentBlockProps {
  imagePosition: SanityLearnMoreModal["imagePosition"];
  textAlign: SanityLearnMoreModal["textAlign"];
  block: SanityLearnMoreModalContentBlock;
}

const LearnMoreModalContentBlock = ({
  block,
  imagePosition,
  textAlign,
}: LearnMoreModalContentBlockProps) => {
  const { content, image, title, subtitle } = block;

  return (
    <Wrapper
      imagePosition={{
        "@md": image ? imagePosition : "noImage",
        "@initial": image ? "top" : "noImage",
      }}
    >
      {image && <Image src={getSanityImgUrl(image.asset._ref, base => base.width(600))} />}

      <TextWrapper style={{ textAlign }}>
        <div style={{ textAlign }}>
          <Heading level={6}>{title}</Heading>
          <Text level={2} prominence="primary">
            {subtitle}
          </Text>
        </div>

        <BlockContent value={content} />
      </TextWrapper>
    </Wrapper>
  );
};

export default LearnMoreModalContentBlock;
